import AssistantChatRuntime from 'components/Chat/AssistantChatRuntime';
import ChatPanelView from 'components/Chat/ChatPanelView';
import { useWebsocket } from 'contexts/websocket';
import useChatPanelViewModel from 'hooks/chat/useChatPanelViewModel';
import { useEffect, useState } from 'react';
import { Loading } from 'shell/components';

const ChatPanelRuntime = ({
    buildOutgoingRequest,
    chat,
    fileKey,
    hasOlderMessages,
    headerEndContent,
    headerStartContent,
    hideBackButton = false,
    hideComposer = false,
    isBootstrapping,
    isLoadingOlderMessages,
    isOpen,
    onBack,
    onChatRequestStateChange,
    onLoadOlderMessages,
    onSuggestionSelected,
    showSuggestions = false,
    suggestions = [],
    suggestionsTitle,
    suggestionsVariant,
    threadFallback = null,
    threadListAdapter,
    beforeContent,
    viewModel,
}) => {
    const { isConnected, onMessage, sendMessage } = useWebsocket();
    const threadViewKey = chat.id || chat.local_id;
    const [shouldScrollThreadToBottom, setShouldScrollThreadToBottom] = useState(isOpen);

    useEffect(() => {
        if (!isOpen) {
            setShouldScrollThreadToBottom(false);
            return;
        }

        setShouldScrollThreadToBottom(true);
    }, [isOpen, threadViewKey]);

    useEffect(() => {
        if (!shouldScrollThreadToBottom) return;

        const frameId = requestAnimationFrame(() => {
            setShouldScrollThreadToBottom(false);
        });

        return () => {
            cancelAnimationFrame(frameId);
        };
    }, [shouldScrollThreadToBottom]);

    if (isBootstrapping) {
        return <Loading />;
    }

    return (
        <AssistantChatRuntime
            buildOutgoingRequest={buildOutgoingRequest}
            chat={chat}
            fileKey={fileKey}
            isConnected={isConnected}
            onChatRequestStateChange={onChatRequestStateChange}
            onMessage={onMessage}
            sendMessage={sendMessage}
            threadListAdapter={threadListAdapter}
        >
            {beforeContent}
            <ChatPanelRuntimeContent
                hasOlderMessages={hasOlderMessages}
                headerEndContent={headerEndContent}
                headerStartContent={headerStartContent}
                hideBackButton={hideBackButton}
                hideComposer={hideComposer || Boolean(threadFallback)}
                isConnected={isConnected}
                isLoadingOlderMessages={isLoadingOlderMessages}
                onBack={onBack}
                onLoadOlderMessages={onLoadOlderMessages}
                onSuggestionSelected={onSuggestionSelected}
                shouldScrollThreadToBottom={shouldScrollThreadToBottom}
                threadViewKey={threadViewKey}
                showSuggestions={showSuggestions}
                suggestions={suggestions}
                suggestionsTitle={suggestionsTitle}
                suggestionsVariant={suggestionsVariant}
                threadFallback={threadFallback}
                viewModel={viewModel}
            />
        </AssistantChatRuntime>
    );
};

const ChatPanelRuntimeContent = (props) => {
    const viewModel = useChatPanelViewModel(props);

    return <ChatPanelView {...viewModel} threadFallback={props.threadFallback} />;
};

export default ChatPanelRuntime;
